import { Component, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { AnnexService } from 'src/app/data/annex.service';
import { AnnexDetailsDto } from 'src/app/models/dtos/annexes/annex-details-dto';
import { AnnexStatusEnum } from 'src/app/models/enums/annex-status-enum';
import { AnnexSyncStatusEnum } from 'src/app/models/enums/annex-sync-status-enum';

@Component({
  selector: 'app-annex-details-panel',
  templateUrl: './annex-details-panel.component.html',
  styleUrls: ['./annex-details-panel.component.scss'],
  standalone: false,
})
export class AnnexDetailsPanelComponent implements OnInit, OnChanges {
  @Input() annexId: number;
  @Input() selectedTabIndex: number = 0;

  private annexService = inject(AnnexService);
  private spinner = inject(NgxSpinnerService);
  private authService = inject(AuthService);

  readonly spinnerName = 'annex-details-panel';

  details: AnnexDetailsDto | null = null;
  isAdmin = false;

  ngOnInit(): void {
    this.isAdmin = this.authService.isAdmin();
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['annexId'] && !changes['annexId'].firstChange) {
      this.loadData();
    }
  }

  getBeforeWageType(wageTypeName: string): string {
    const wage = this.details?.WorkerAgreement?.Wages?.find(w => w.WageTypeName === wageTypeName);
    return wage?.WageTypeName ?? '';
  }

  getBeforeWage(wageTypeName: string): string {
    const wage = this.details?.WorkerAgreement?.Wages?.find(w => w.WageTypeName === wageTypeName);
    if (!wage) {
      return '';
    }
    return `${wage.Value?.toFixed(2)} ${wage.CurrencyName}`;
  }

  getExternalSyncStatusClass(statusId: number | null): string {
    switch (statusId) {
      case AnnexSyncStatusEnum.Pending:   return 'label--orange';
      case AnnexSyncStatusEnum.InProcess: return 'label--blue';
      case AnnexSyncStatusEnum.Success:   return 'label--green';
      case AnnexSyncStatusEnum.Error:     return 'label--red';
      default: return '';
    }
  }

  getStatusClass(statusId: number): string {
    switch (statusId) {
      case AnnexStatusEnum.Active:
      case AnnexStatusEnum.Accepted:              return 'label--green';
      case AnnexStatusEnum.PendingApproval:        return 'label--yellow';
      case AnnexStatusEnum.GeneratingSignedAnnex:  return 'label--blue';
      case AnnexStatusEnum.Inactive:
      case AnnexStatusEnum.TerminatedAnnex:        return 'label--orange';
      default:                                     return '';
    }
  }

  private loadData(): void {
    this.details = null;
    const annexId = this.annexId;
    this.spinner.show(this.spinnerName);

    this.annexService.getAnnexDetails(annexId).subscribe({
      next: (response: AnnexDetailsDto) => {
        if (this.annexId !== annexId)
        {
          return;
        }

        this.details = response;
        if (response?.Annex?.IsImported) {
          this.selectedTabIndex = 0;
        }
        this.spinner.hide(this.spinnerName);
      },
      error: () => {
        if (this.annexId !== annexId)
        {
          return;
        }

        this.spinner.hide(this.spinnerName);
      },
    });
  }
}
